import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CCol,
  CButton,
  CRow,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CTabs,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CTooltip,
  CPagination,
  CPopover
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import EvaluationStatistics from "./evaluationStatistics";
import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ImgNoData from "../../../../assets/imgs/graduation.svg";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Cards from "../../../../components/Cards/Cards";
import TextCreator from "../../../../components/Content/TextCreator";
import CorrectLiterarte from "../../../../components/CorrectLiterarte";
import Interface from "../../../../components/Interface";
import LiterarteModal from "../../../../components/LiterarteModal";
import Loading from "../../../../components/Loading";
import ModalTools from "../../../../components/ModalTools";
import RichText from "../../../../components/RichText/SlateEditor/Editor";
import ShareModal from "../../../../components/ShareModal";
import Statistics from "../../../../components/Statistics/StatisticsActivityDo/statisticsActivityDo";
import UploadModal from "../../../../components/UploadModal";
import Widgets from "../../../../components/Widgets/Widgets";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { baseDate } from "../../../../utils/date";
import QuestionListDo from "../../../Evaluation/QuestionList/Do/index";
// import Literarte from '../../../../components/SlateComponents/Literarte';
import "../../../../scss/style2.scss";

const FileDownload = require("js-file-download");

class ActivityDo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      objToStatistics: {},
      // response: false,
      studentsList: [],
      studentsListPage: 1,
      studentsListLastPage: 1,
      // user: {},
      activity: null,
      // room_id: null,
      activity_id: null,
      allocation_id: this.props.match.params.allocation_id,
      activity_name: "",
      // message: "",
      loading: true,
      itemStartTimes: {},
      iframe: false,
      // questions: [],
      // listQuestion: {
      //   id: "",
      //   show: false,
      //   average: 0,
      //   time: null
      // },
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      correctLiterarte: {
        id: "",
        show: false
      },
      youtubeModal: {
        show: false,
        title: "",
        urlID: ""
      },
      // ability_list: [],
      contentId: "",
      contentName: "",
      // totalActivityItems: 0,
      uploadModal: false,
      modalTool: false,
      toolName: null,
      toolId: null,
      evaluationStatisticsModal: false,
      statisticsModal: false,
      shareModal: false,
      item_id: null,
      literarteStart: null,
      url: null,
      hasPermission: false,
      textModal: false,
      lo_id: null,
      questionListModal: false, // Controle do modal
      currentItem: null
      // executionQuantity: null
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  createExecution(callback = () => null) {
    const obj = {
      allocation_id: this.state.allocation_id
    };

    axios
      .post(`${URL.api}activity/execution/insertByAllocation`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ execution_id: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      });
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.verifyPermission(() =>
      this.handleActivity(() => this.initializeActivity())
    );
  }

  // async changeStudentsListPage(page) {
  //   if (page < 1 || page > this.state.studentsListLastPage) return;
  //   this.setState({ studentsListPage: page }, () => this.initializeActivity());
  // }

  // renderStudentsListPageButtons() {
  //   let buttons = [];
  //   for (let index = 0; index < this.state.studentsListLastPage; index++) {
  //     buttons.push(
  //       <button
  //         key={index}
  //         className={`rounded-circle d-flex align-items-center justify-content-center p-2 mx-1 ${
  //           index + 1 === this.state.studentsListPage
  //             ? "bg-secondary"
  //             : "bg-light"
  //         }`}
  //         style={{ height: "32px", width: "32px" }}
  //         onClick={() => this.changeStudentsListPage(index + 1)}
  //       >
  //         {index + 1}
  //       </button>
  //     );
  //   }

  //   return buttons;
  // }

  verifyPermission(callback = () => {}) {
    const { allocation_id: allocationId } = this.state;

    axios
      .get(`${URL.api}activity/allocate/permissions`, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        },
        params: {
          allocation_id: allocationId
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ hasPermission: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao verificar permissões!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao verificar permissões!");
        }
      });
  }

  handleActivity(callback = () => null) {
    if (!this.state.hasPermission) {
      this.createExecution(() => {
        axios
          .get(
            `${URL.api}activity/activity/singleViewByExecution/${this.state.execution_id}?allocation_id=${this.state.allocation_id}`,
            {
              headers: {
                authorization: `Bearer ${this.props.user.token}`,
                "Access-Control-Allow-Origin": "*"
              }
            }
          )
          .then(resp => {
            if (resp.data.success) {
              const activity = {
                ...resp.data.data,
                items: resp.data.data.items.map(item => ({
                  ...item,
                  title: item.name,
                  subtitle: item.type_name
                }))
              };
              this.setState(
                {
                  activity,
                  itens: activity.items
                  // executionQuantity: resp.data.data.executionQuantity
                },
                () => {
                  callback();
                }
              );
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.error("Sua sessão expirou!");
              this.props.logout();
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          });
      });
    } else {
      axios
        .get(
          `${URL.api}activity/activity/singleViewByAllocation/${this.state.allocation_id}`,
          {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          }
        )
        .then(resp => {
          if (resp.data.success) {
            const activity = {
              ...resp.data.data,
              items: resp.data.data.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };

            this.setState(
              {
                activity,
                itens: activity.items
              },
              () => {
                callback();
              }
            );
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.error("Sua sessão expirou!");
            this.props.logout();
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        });
    }
  }

  initializeActivity() {
    let user = {
      id: this.props.user.user.id,
      name: this.props.user.user.username
    };

    const objActivityAllocate = {
      activity_id: this.state.activity.id,
      room_id: this.state.activity.room_id,
      user_id: 0
    };

    const objRoomUser = { room: this.state.activity.room_id };

    const objExecutionItem = { activity_id: this.state.activity.id };

    axios
      .all([
        axios.post(`${URL.api}activity/execution/item/list`, objExecutionItem, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}activity/allocate/list`, objActivityAllocate, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}activity/allocate/guests`, objActivityAllocate, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(
          `${URL.api}community/room_user/listPaginate?page=${this.state.studentsListPage}`,
          objRoomUser,
          {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        )
      ])
      .then(
        axios.spread(
          (
            respExecutionItem,
            respAllocate,
            respAllocateGuests,
            respUsersList
          ) => {
            let studentsList = [];

            // listar usuarios da turma e alocados
            for (let i = 0; i < respAllocate.data.data[0].users.length; i++) {
              for (let j = 0; j < respUsersList.data.data.users.length; j++) {
                if (
                  respAllocate.data.data[0].users[i].user_id ===
                  respUsersList.data.data.users[j].user_id
                ) {
                  if (!respUsersList.data.data.users[j].administrator) {
                    let obj = {
                      id: respUsersList.data.data.users[j].user_id,
                      name: respUsersList.data.data.users[j].user_name,
                      online: "desconectado",
                      color: "primary",
                      activity: "",
                      profileImage:
                        URL.img +
                        (respUsersList.data.data.users[j].user_photo ||
                          "uploads/users/profileEmpty.jpg"),
                      role_id: 7,
                      execution_items: respExecutionItem.data.data.filter(
                        item =>
                          item.user_id ===
                          respUsersList.data.data.users[j].user_id
                      ),
                      items: this.state.itens.length
                    };
                    studentsList.push(obj);
                  }
                }
              }
            }

            for (let i = 0; i < respAllocateGuests.data.data.length; i++) {
              let obj = {
                id: respAllocateGuests.data.data[i].user_id,
                name: respAllocateGuests.data.data[i].user_name,
                online: "desconectado",
                color: "primary",
                activity: "",
                profileImage:
                  URL.img +
                  (respAllocateGuests.data.data[i].user_photo ||
                    "uploads/users/profileEmpty.jpg"),
                role_id: 9,
                execution_items: respExecutionItem.data.data.filter(
                  item =>
                    item.user_id === respAllocateGuests.data.data[i].user_id
                ),
                items: this.state.itens.length
              };

              studentsList.push(obj);
            }

            // listar itens
            let listQuestion = {
              id: "",
              show: false,
              average: 0,
              time: null
            };

            const activity = {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.activity,
              // eslint-disable-next-line react/no-access-state-in-setstate
              items: this.state.activity.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };
            this.setState({
              loading: false,
              activity,
              studentsListLastPage: respUsersList.data.meta.last_page,
              activity_id: activity.id,
              // response: true,
              activity_name: activity.name,
              activity_description_box: {
                type: 0,
                text: activity.description
              },
              // listQuestion,
              // totalActivityItems: activity.items.length,
              studentsList,
              // user,
              itens: activity.items
            });
          },
          error => {
            this.error("Não foi possível obter informações sobre a atividade");
          }
        )
      );
  }

  closeLeft() {
    document.getElementById("leftSide").style.display = "none";
    document.getElementById("closeLeft").style.display = "none";
    document.getElementById("openLeft").style.display = "block";
  }

  openLeft() {
    document.getElementById("leftSide").style.display = "block";
    document.getElementById("closeLeft").style.display = "block";
    document.getElementById("openLeft").style.display = "none";
  }

  closeRight() {
    document.getElementById("rightSide").style.display = "none";
    document.getElementById("closeRight").style.display = "none";
    document.getElementById("openRight").style.display = "block";
  }

  openRight() {
    document.getElementById("rightSide").style.display = "block";
    document.getElementById("closeRight").style.display = "block";
    document.getElementById("openRight").style.display = "none";
  }

  createItemExecutionOnClose = (itemId, callback = () => null) => {
    const late = Date.parse(this.state.activity.activity_end) < Date.now();
    const item = this.state.itens.find(i => i.id === itemId);

    if (late || this.state.hasPermission || !item) {
      callback();
      return;
    }

    const startTime = this.state.itemStartTimes[itemId] || new Date();
    const endTime = new Date();

    const obj = {
      execution_id: this.state.execution_id,
      item_id: itemId,
      completion_percentage: 100,
      start: baseDate(startTime), // Horário real de início
      end: baseDate(endTime) // Horário real de finalização
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          // Limpar o horário de início armazenado
          this.setState(prevState => {
            const newStartTimes = { ...prevState.itemStartTimes };
            delete newStartTimes[itemId];
            return { itemStartTimes: newStartTimes };
          });
          callback();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      });
  };

  openYoutubePlayer = (name, url) => {
    let urlID = "";

    if (
      url.match(
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/)((\w|-){11})(?:\S+)?$/
      )
    ) {
      urlID = url.split("youtu.be/")[1].split("?")[0];
    } else if (
      url.match(
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
      )
    ) {
      urlID = url.split("v=")[1].split("&")[0];
    }

    this.setState(prevState => ({
      youtubeModal: {
        ...prevState.youtubeModal,
        show: true,
        title: name,
        urlID
      }
    }));
  };

  updateCompletionItem = item => {
    this.createItemExecutionOnClose(item.id, () => this.handleActivity());
  };

  openItem = item => {
    const late = Date.parse(this.state.activity.activity_end) < Date.now();

    this.setState(prevState => ({
      itemStartTimes: {
        ...prevState.itemStartTimes,
        [item.id]: new Date() // Armazena o horário atual
      }
    }));

    if (item.type_id === 12) {
      // AVALIAÇÃO
      this.setState({
        currentItem: item,
        questionListModal: true
      });
    } else if (item.type_id === 15) {
      // NEWTON
      this.setState({
        modalTool: true,
        toolId: item.type_id,
        toolName: item.title,
        item_id: item.id
      });
    } else if (item.type_id === 16 || item.type_id === 27) {
      // LINK
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            const youtubeLinkStructure =
              /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

            if (resp.data.data.path.match(youtubeLinkStructure)) {
              this.openYoutubePlayer(item.name, resp.data.data.path);
              if (!this.state.hasPermission) {
                this.createItemExecutionOnClose(item.id, () =>
                  this.handleActivity()
                );
              }
            } else {
              window.open(resp.data.data.path, "_blank");
              if (!this.state.hasPermission) {
                setTimeout(() => {
                  this.createItemExecutionOnClose(item.id, () =>
                    this.handleActivity()
                  );
                }, 1000);
              }
            }
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (item.type_id === 33) {
      this.setState({ lo_id: item.obj_id, textModal: true, item_id: item.id });
    } else if (item.type_id === 14) {
      // LITERARTE
      if (late && item.item_percentage !== 100) {
        toastr.warning("Atenção", "A atividade já foi encerrada!");
        return;
      }

      this.setState(prevState => ({
        textProduction: {
          ...prevState.textProduction,
          show: true,
          id: item.obj_id
        },
        currentItem: item,
        item_id: item.id,
        contentName: item.title,
        literarteStart: new Date()
      }));
    } else if (item.type_id === 18) {
      if (this.props.user.user_roles[0].role_name === "Aluno") {
        if (item.item_percentage === 100) {
          // Substitui o toastr pelo modal
          this.setState({
            gradeModal: {
              show: true,
              grade: item.item_grade,
              itemName: item.title
            }
          });
        } else {
          this.setState({
            uploadModal: true,
            contentId: item.obj_id,
            contentName: item.title,
            item_id: item.id
          });
        }
      }
    } else if (item.type_id !== 17) {
      this.setState({
        iframe: true,
        contentId: item.obj_id,
        contentName: item.title,
        item_id: item.id
      });
    } else {
      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);
          // Para downloads, registrar conclusão imediatamente
          if (!this.state.hasPermission) {
            setTimeout(() => {
              this.createItemExecutionOnClose(item.id, () =>
                this.handleActivity()
              );
            }, 1000);
          }
        });
    }
  };

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: this.state.textProduction.id,
      pages: pagesObj,
      item_id: this.state.item_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Sucesso", "O texto foi salvo.");
          this.updateCompletionItem(this.state.currentItem);
          this.setState({
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              show: false
            }
          });
        }
      });
  };

  render() {
    const late =
      !this.state.loading &&
      new Date(this.state.activity?.activity_end) < new Date();

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: "/classroom/me", to: "/classroom/me" },
            {
              path: "/classroom/:id/activities",
              to: `/classroom/${this.state.activity?.room_id}/activities`
            }
          ]}
        />

        <CModal
          show={this.state.gradeModal?.show || false}
          onClose={() =>
            this.setState({
              gradeModal: { show: false, grade: null, itemName: "" }
            })
          }
          centered
        >
          <CModalHeader>
            <CModalTitle>
              {this.state.gradeModal?.grade !== null &&
              this.state.gradeModal?.grade !== undefined
                ? "Item Entregue - Corrigido"
                : "Item Entregue - Aguardando Correção"}
            </CModalTitle>
          </CModalHeader>
          <CModalBody className="text-center">
            <div className="d-flex flex-column align-items-center">
              <i className="fa fa-check-circle text-success fa-3x mb-3"></i>
              <h4>Item Concluído</h4>
              <p className="mb-0">
                {this.state.gradeModal?.grade !== null &&
                this.state.gradeModal?.grade !== undefined
                  ? `Sua nota: ${this.state.gradeModal.grade}`
                  : "Aguardando correção"}
              </p>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="primary"
              onClick={() =>
                this.setState({
                  gradeModal: { show: false, grade: null, itemName: "" }
                })
              }
            >
              Fechar
            </CButton>
          </CModalFooter>
        </CModal>

        {this.state.questionListModal && (
          <CModal
            show={this.state.questionListModal}
            onClose={() => {
              if (this.state.currentItem?.id && !this.state.hasPermission) {
                this.createItemExecutionOnClose(this.state.currentItem.id, () =>
                  this.handleActivity()
                );
              }
              this.setState({ questionListModal: false });
            }}
            centered
            size="lg w-100 h-100 m-0 mw-100"
            style={{ width: "100%", height: "100%" }}
            closeOnBackdrop={false}
          >
            <CModalHeader>
              <div className="w-100 d-flex justify-content-between">
                <CModalTitle>{this.state.currentItem.name}</CModalTitle>
                <CButton
                  color="secondary"
                  onClick={() => this.setState({ questionListModal: false })}
                >
                  Fechar
                </CButton>
              </div>
            </CModalHeader>
            <CModalBody>
              {this.state.activity_id && (
                <QuestionListDo
                  updateCompletionItem={this.updateCompletionItem}
                  currentItem={this.state.currentItem}
                  match={{
                    params: {
                      activity_id: this.state.activity_id
                    }
                  }}
                  history={this.props.history}
                  currentRoute={this.props.currentRoute}
                />
              )}
            </CModalBody>
          </CModal>
        )}
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() => {
              if (this.state.item_id && !this.state.hasPermission) {
                this.createItemExecutionOnClose(
                  this.state.item_id,

                  () => this.handleActivity()
                );
              }
              this.setState({ iframe: false });
            }}
            aula={this.state.contentId}
            atividade={this.state.activity_id}
            act_item_id={this.state.item_id}
            act_execution_id={late ? undefined : this.state.execution_id}
            currentRoute={this.props.currentRoute}
            url={!this.state.contentId && this.state.url}
          />
        )}
        <ModalTools
          show={this.state.modalTool}
          tool={this.state.toolId}
          title={this.state.toolName}
          onClose={() => {
            if (this.state.item_id && !this.state.hasPermission) {
              this.createItemExecutionOnClose(
                this.state.item_id,

                () => this.handleActivity()
              );
            }
            this.setState({ modalTool: false });
          }}
          activity={this.state.activity_id}
          students={this.state.studentsList}
          currentRoute={this.props.currentRoute}
        />
        {this.state.activity?.room_id &&
          this.state.evaluationStatisticsModal && (
            <EvaluationStatistics
              objToStatistics={this.state.objToStatistics}
              show={this.state.evaluationStatisticsModal}
              onClose={() =>
                this.setState({ evaluationStatisticsModal: false })
              }
              allocation_id={this.state.allocation_id}
              room_id={this.state.activity?.room_id}
              activity={this.state.activity_id}
              currentRoute={this.props.currentRoute}
            />
          )}
        <Statistics
          show={this.state.statisticsModal}
          onClose={() => this.setState({ statisticsModal: false })}
          allocation_id={this.state.allocation_id}
          activity={this.state.activity_id}
          currentRoute={this.props.currentRoute}
        />
        <ShareModal
          show={this.state.shareModal}
          onClose={() => this.setState({ shareModal: false })}
          link={window.location.href}
        />
        {this.state.uploadModal && (
          <UploadModal
            onClose={() => {
              if (this.state.item_id && !this.state.hasPermission) {
                this.createItemExecutionOnClose(
                  this.state.item_id,

                  () => this.handleActivity()
                );
              }
              this.setState({ uploadModal: false });
            }}
            upload_id={this.state.contentId}
            activity_id={this.state.activity_id}
            item_id={this.state.item_id}
            execution_id={this.state.execution_id}
          />
        )}
        {this.state.textProduction.id !== "" ? (
          <LiterarteModal
            id={this.state.textProduction.id}
            user_id={this.props.user.user.id}
            show={this.state.textProduction.show}
            onClose={() =>
              this.setState(
                {
                  textProduction: {
                    // eslint-disable-next-line react/no-access-state-in-setstate
                    ...this.state.textProduction,
                    show: false
                  }
                },
                () => this.handleActivity()
              )
            }
            title={this.state.contentName}
            value={this.state.textProduction.value}
            onChange={value =>
              this.setState({
                textProduction: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.textProduction,
                  value
                }
              })
            }
            saveTextProduction={pages => this.saveTextProduction(pages)}
          />
        ) : null}
        {this.state.correctLiterarte && (
          <CorrectLiterarte
            id={this.state.correctLiterarte.id}
            show={this.state.correctLiterarte.show}
            onClose={() =>
              this.setState({
                correctLiterarte: {
                  // eslint-disable-next-line react/no-access-state-in-setstate
                  ...this.state.correctLiterarte,
                  show: false
                }
              })
            }
            user_id={this.props.user.user.id}
          />
        )}
        {this.state.textModal && (
          <TextCreator
            show={this.state.textModal}
            onClose={() => {
              if (this.state.item_id && !this.state.hasPermission) {
                this.createItemExecutionOnClose(
                  this.state.item_id,

                  () => this.handleActivity()
                );
              }
              this.setState({
                textModal: false
              });
            }}
            // eslint-disable-next-line react/jsx-boolean-value
            showOnly={true}
            currentLOLink={this.state.lo_id}
          />
        )}
        <CModal
          show={this.state.youtubeModal.show}
          onClose={() => {
            if (this.state.item_id && !this.state.hasPermission) {
              this.createItemExecutionOnClose(
                this.state.item_id,

                () => this.handleActivity()
              );
            }
            this.setState(prevState => ({
              youtubeModal: {
                ...prevState.youtubeModal,
                show: false,
                urlID: ""
              }
            }));
          }}
          size="lg w-100 h-100 m-0 p-5 mw-100"
          style={{ width: "100%", height: "100%" }}
          closeOnBackdrop
        >
          <CModalHeader>
            <CModalTitle>{this.state.youtubeModal.title}</CModalTitle>
            <button
              onClick={() =>
                this.setState(prevState => ({
                  youtubeModal: {
                    ...prevState.youtubeModal,
                    show: false
                  }
                }))
              }
            >
              <i className="fa fa-close text-secondary"></i>
            </button>
          </CModalHeader>
          <CModalBody>
            <iframe
              title="youtube"
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${this.state.youtubeModal.urlID}?autoplay=0`}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              // style={{ minHeight: "80vh" }}
            ></iframe>
          </CModalBody>
          <CModalFooter>
            <a
              href={`https://youtu.be/${this.state.youtubeModal.urlID}`}
              target="_blank"
              rel="noreferrer"
            >
              Abrir link em outra guia
              <i className="fa fa-external-link ml-1"></i>
            </a>
          </CModalFooter>
        </CModal>
        {!this.state.loading ? (
          <>
            <CTabs activeTab="activity">
              <CNav variant="tabs">
                <CNavItem>
                  <CNavLink data-tab="activity">Atividade</CNavLink>
                </CNavItem>
                {this.props.user.user_roles[0].role_id !== 7 && (
                  <CNavItem>
                    <CNavLink data-tab="students">Estudantes</CNavLink>
                  </CNavItem>
                )}
              </CNav>
              <CTabContent>
                <CTabPane data-tab="activity">
                  <CRow className="d-flex align-items-center justify-content-between">
                    <CCol
                      xs="12"
                      md="6"
                      className="mb-2 mb-md-0 d-flex align-items-center"
                    >
                      <h4 className="m-0">
                        <strong>{this.state.activity_name}</strong>
                      </h4>
                      {late && (
                        <div className="is-late">
                          <span>Expirado</span>
                        </div>
                      )}
                    </CCol>
                    <CCol
                      xs="12"
                      md="6"
                      className="d-flex align-items-center justify-content-between"
                    >
                      <div className="d-flex flex-column">
                        <span>
                          <strong>Início</strong>
                        </span>
                        <p className="m-0">
                          {
                            this.state.activity.activity_start
                              .split(" ")[0]
                              .split("-")[2]
                          }
                          /
                          {
                            this.state.activity.activity_start
                              .split(" ")[0]
                              .split("-")[1]
                          }
                          /
                          {
                            this.state.activity.activity_start
                              .split(" ")[0]
                              .split("-")[0]
                          }{" "}
                          {this.state.activity.activity_start.split(" ")[1]}
                        </p>
                      </div>
                      <div className="d-flex flex-column ml-3">
                        <span>
                          <strong>Final:</strong>
                        </span>
                        <p className="m-0">
                          {
                            this.state.activity.activity_end
                              .split(" ")[0]
                              .split("-")[2]
                          }
                          /
                          {
                            this.state.activity.activity_end
                              .split(" ")[0]
                              .split("-")[1]
                          }
                          /
                          {
                            this.state.activity.activity_end
                              .split(" ")[0]
                              .split("-")[0]
                          }{" "}
                          {this.state.activity.activity_end.split(" ")[1]}
                        </p>
                      </div>
                      {this.state.hasPermission && (
                        <div className="d-flex align-items-center mx-2">
                          <button
                            onClick={
                              this.state.hasPermission
                                ? () => this.setState({ shareModal: true })
                                : null
                            }
                          >
                            <i className="fa fa-share-alt text-primary"></i>
                          </button>
                          <button
                            onClick={
                              this.state.hasPermission
                                ? () => this.setState({ statisticsModal: true })
                                : null
                            }
                          >
                            <i className="fa fa-pie-chart mx-1 text-primary"></i>
                          </button>
                          <button
                            onClick={
                              this.state.hasPermission
                                ? () =>
                                    this.handleActivity(() =>
                                      this.initializeActivity()
                                    )
                                : null
                            }
                          >
                            <i className="fa fa-rotate-left text-primary"></i>
                          </button>
                        </div>
                      )}
                    </CCol>
                  </CRow>
                  <hr />

                  {this.state.activity_description_box.type === 1 ? (
                    <div className="row align-items-center">
                      <div className="col-9">
                        <h2>{this.state.activity_description_box.title}</h2>
                        <h6>
                          <small>
                            {this.state.activity_description_box.subtitle}
                          </small>
                        </h6>
                      </div>
                      <div className="col-3">
                        <button
                          className="btn btn-primary"
                          type="button"
                          style={{ float: "right" }}
                        >
                          {this.state.activity_description_box.text_button}
                        </button>
                      </div>
                    </div>
                  ) : this.state.activity_description_box.type === 2 ? (
                    <div>
                      {this.state.activity_description_box.items?.length ? (
                        this.state.activity_description_box.items.map(
                          (item, index) => (
                            <div key={index} className="cards-activity-item">
                              <div className="d-flex align-items-center">
                                <div
                                  className={`cards-activity-icon-container${
                                    item.activity_percentage
                                      ? " done"
                                      : new Date(item.activity_end) < new Date()
                                      ? " late"
                                      : ""
                                  }`}
                                >
                                  <i className="fa fa-line-chart"></i>
                                </div>
                              </div>
                              <div
                                className="d-flex flex-column justify-content-center"
                                style={{ flex: 1 }}
                              >
                                <div
                                  className="cards-activity-title"
                                  onClick={() =>
                                    this.props.function(item.allocation_id)
                                  }
                                >
                                  {item.name}
                                </div>
                                <div className="d-flex">
                                  <span className="small text-muted">
                                    {item.activity_percentage
                                      ? "Concluída"
                                      : new Date(item.activity_end) < new Date()
                                      ? "Atrasada"
                                      : "A fazer"}
                                  </span>
                                  {item.activity_percentage ? (
                                    <span className="small text-success ml-1">
                                      ({item.activity_percentage}%)
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhuma atividade a ser mostrada
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 3 ? (
                    <div>
                      {this.state.activity_description_box.items?.length ? (
                        this.state.activity_description_box.items.map(
                          (item, index) => (
                            <div key={index} className="cards-discussion-item">
                              <div className="d-flex align-items-center cards-discussion-avatar">
                                <div
                                  className="img-fluid"
                                  style={{
                                    width: "100%",
                                    paddingTop: "100%",
                                    backgroundImage: `url("${URL.img}${
                                      item.user_photo ||
                                      "uploads/users/profileEmpty.jpg"
                                    }")`,
                                    backgroundSize: "100% 100%",
                                    borderRadius: "100%"
                                  }}
                                ></div>
                              </div>
                              <div
                                className="d-flex flex-column justify-content-center text-ellipsis"
                                style={{ flex: 1 }}
                              >
                                <div
                                  className="cards-discussion-title text-ellipsis"
                                  onClick={() => this.props.function(item.id)}
                                >
                                  {item.title}
                                </div>
                                <span className="small text-muted text-ellipsis">
                                  {item.description}
                                </span>
                              </div>
                            </div>
                          )
                        )
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhuma discussão a ser mostrada
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 4 ? (
                    <div>
                      {this.state.activity_description_box.items?.length ? (
                        <div
                          className="row justify-content-center"
                          style={{ marginBottom: "-15px" }}
                        >
                          {this.state.activity_description_box.items.map(
                            (item, index) => (
                              <div
                                key={index}
                                className="col-4"
                                style={{ marginBottom: "15px" }}
                              >
                                <CTooltip
                                  content={item.user_name}
                                  placement="top"
                                >
                                  <div
                                    className="img-fluid"
                                    style={{
                                      cursor: "pointer",
                                      paddingTop: "100%",
                                      backgroundImage: `url("${URL.img}${
                                        item.user_photo ||
                                        "uploads/users/profileEmpty.jpg"
                                      }")`,
                                      backgroundSize: "100% 100%",
                                      borderRadius: "100%"
                                    }}
                                    onClick={() =>
                                      this.props.history.push(
                                        `/profile/${item.user_id}`
                                      )
                                    }
                                  ></div>
                                </CTooltip>
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhum membro a ser mostrado
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 5 ? (
                    <div>
                      {this.state.activity_description_box.items.length ? (
                        <div
                          className="row"
                          style={{
                            marginBottom: "-0.5rem",
                            marginTop: "-0.5rem",
                            marginLeft: "-0.5rem",
                            marginRight: "-0.5rem"
                          }}
                        >
                          {this.state.activity_description_box.items.map(
                            (item, index) => (
                              <CCol
                                sm={6}
                                key={index}
                                style={{
                                  marginBottom: "0.5rem",
                                  marginTop: "0.5rem",
                                  paddingLeft: "0.5rem",
                                  paddingRight: "0.5rem"
                                }}
                              >
                                <CCard
                                  className={`m-0 ${
                                    this.state.docSelected === item.id
                                      ? "doc-selected"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.setState({ docSelected: item.id })
                                  }
                                  onDoubleClick={() =>
                                    this.props.openUrl(item.name, item.link)
                                  }
                                >
                                  <CCardBody
                                    style={{
                                      pointerEvents: "none",
                                      userSelect: "none"
                                    }}
                                  >
                                    <div className="text-ellipsis text-center">
                                      <i className="fa fa-file text-danger mr-3"></i>
                                      {item.name}
                                    </div>
                                  </CCardBody>
                                </CCard>
                              </CCol>
                            )
                          )}
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhum documento a ser mostrado
                        </div>
                      )}
                    </div>
                  ) : this.state.activity_description_box.type === 6 ? (
                    <div>
                      {this.state.activity_description_box.items.length ? (
                        <div
                          className="row"
                          style={{
                            marginBottom: "-0.5rem",
                            marginTop: "-0.5rem",
                            marginLeft: "-0.5rem",
                            marginRight: "-0.5rem"
                          }}
                        >
                          {this.state.activity_description_box.items.map(
                            (item, index) => (
                              <CCol
                                sm={6}
                                key={index}
                                style={{
                                  marginBottom: "0.5rem",
                                  marginTop: "0.5rem",
                                  paddingLeft: "0.5rem",
                                  paddingRight: "0.5rem"
                                }}
                              >
                                <CCard
                                  className={`m-0 ${
                                    this.state.docSelected === item.id
                                      ? "doc-selected"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.setState({ docSelected: item.id })
                                  }
                                  onDoubleClick={() =>
                                    this.props.function(item.link)
                                  }
                                >
                                  <CCardBody
                                    style={{
                                      pointerEvents: "none",
                                      userSelect: "none"
                                    }}
                                  >
                                    <div className="text-ellipsis text-center">
                                      <i className="fa fa-video-camera mr-3"></i>
                                      {item.activity_name
                                        ? `Gravação de ${item.activity_name}`
                                        : decodeURIComponent(
                                            item.link.split("/").splice(-1)[0]
                                          )}
                                    </div>
                                  </CCardBody>
                                </CCard>
                              </CCol>
                            )
                          )}
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center text-muted text-center">
                          Nenhuma gravação a ser mostrada
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {this.state.activity_description_box.text !==
                      undefined ? (
                        this.state.activity_description_box.text.substring(
                          0,
                          1
                        ) === "[" ? (
                          <RichText
                            description={
                              this.state.activity_description_box.text
                            }
                            editavel={false}
                          />
                        ) : (
                          <div>{this.state.activity_description_box.text}</div>
                        )
                      ) : (
                        <div></div>
                      )}
                    </>
                  )}

                  <h5 className="mt-3">
                    <strong>Objetos</strong>
                  </h5>
                  <hr />
                  {this.state.hasPermission ? (
                    <Widgets
                      itens={this.state.itens}
                      openItem={this.openItem}
                      closeItem={this.closeItem}
                      sequentialExecution={
                        this.state.activity.sequential_execution
                      }
                      teacher
                      onEvaluationStatistics={id => {
                        this.setState({
                          evaluationStatisticsModal: true,
                          objToStatistics: {
                            // eslint-disable-next-line react/no-access-state-in-setstate
                            activity_id: this.state.activity_id,
                            item_id: id
                          }
                        });
                      }}
                    />
                  ) : (
                    <>
                      {new Date(this.state.activity.activity_start) >
                        new Date() && !this.state.activity.activity_release ? (
                        <CRow className="flex-1">
                          <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                            <img
                              src={ImgNoData}
                              style={{ height: "240px", marginBottom: "2rem" }}
                              alt=""
                            />
                            <p
                              style={{ fontSize: "1.5rem" }}
                              className="mb-2 font-weight-bold text-center"
                            >
                              A atividade ainda não foi liberada
                            </p>
                            <span className="text-muted text-center">
                              Tente voltar daqui a alguns minutos
                            </span>
                          </div>
                        </CRow>
                      ) : (
                        <CRow className="flex-1">
                          {this.state.itens.length > 0 ? (
                            <CCol lg="12">
                              <div id="leftSide">
                                {/* AQUIII */}
                                <Widgets
                                  late={late}
                                  itens={this.state.itens}
                                  openItem={this.openItem}
                                  sequentialExecution={
                                    this.state.activity.sequential_execution
                                  }
                                  completionMark
                                />
                              </div>
                            </CCol>
                          ) : (
                            <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                              <img
                                src={ImgNoData}
                                style={{
                                  height: "240px",
                                  marginBottom: "2rem"
                                }}
                                alt=""
                              />
                              <p
                                style={{ fontSize: "1.5rem" }}
                                className="mb-2 font-weight-bold text-center"
                              >
                                Nenhum conteúdo foi liberado
                              </p>
                              <span className="text-muted text-center">
                                Entre em contato com seu professor
                              </span>
                            </div>
                          )}
                        </CRow>
                      )}
                    </>
                  )}
                </CTabPane>
                <CTabPane data-tab="students">
                  {this.state.studentsList.map((student, index) => (
                    <CRow className="border-bottom m-0" key={index}>
                      <CCol
                        xs="12"
                        sm="8"
                        className="d-flex flex-row align-items-center"
                      >
                        <div className="position-relative mr-2">
                          <img
                            src={student.profileImage}
                            className="m-2 rounded-circle"
                            style={{ width: "42px", height: "42px" }}
                          />
                          <CPopover
                            header="Informações"
                            content={
                              <>
                                {this.state.itens.map(activityItem => (
                                  <div key={activityItem.id}>
                                    <strong>{activityItem.title}: </strong>{" "}
                                    {(() => {
                                      const execution =
                                        student.execution_items.find(
                                          executionItem =>
                                            executionItem.item_id ===
                                            activityItem.id
                                        );

                                      if (execution) {
                                        return execution.completion_percentage !==
                                          100
                                          ? "A fazer"
                                          : execution.final_grade !== null
                                          ? `${execution.final_grade}`
                                          : "Concluído";
                                      }

                                      return "A fazer";
                                    })()}
                                  </div>
                                ))}
                              </>
                            }
                            placement="right"
                          >
                            <div
                              className="position-absolute cursor bg-white rounded-circle p-1"
                              style={{
                                right: "4px",
                                bottom: "4px",
                                lineHeight: 1
                              }}
                            >
                              <i
                                className="fa fa-info text-primary text-center"
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  fontSize: "14px"
                                }}
                              ></i>
                            </div>
                          </CPopover>
                        </div>
                        <div className="d-flex flex-column">
                          <span>
                            <strong>{student.name}</strong>
                          </span>
                          <small>
                            Concluiu:{" "}
                            {(() => {
                              const completionPercentage =
                                student.execution_items.reduce(
                                  (acc, val) =>
                                    acc + (val.completion_percentage || 0),
                                  0
                                ) / student.items;
                              return Math.min(
                                completionPercentage.toFixed(0),
                                100
                              );
                            })()}
                            %
                          </small>
                        </div>
                      </CCol>
                      <CCol
                        xs="12"
                        sm="4"
                        className="d-flex align-items-center justify-content-end"
                      >
                        <CButton
                          color="primary"
                          className="col-12 col-sm-auto my-2 my-sm-0"
                          onClick={() =>
                            this.props.history.push(
                              `/${
                                this.props.isTrailActivity
                                  ? "trail"
                                  : "activity"
                              }/do/${
                                this.props.match.params.allocation_id
                              }/correct/${
                                student.execution_items.length
                                  ? student.execution_items[0].execution_id
                                  : 0
                              }`
                            )
                          }
                        >
                          Resultados
                        </CButton>
                      </CCol>
                    </CRow>
                  ))}
                  {/* <div className="d-flex flex-row pt-3 align-items-center justify-content-center w-100 h-100">
                    <button
                      className="rounded-circle bg-primary d-flex align-items-center justify-content-center p-2"
                      style={{ height: "32px", width: "32px" }}
                      disabled={this.state.studentsListPage === 1}
                      onClick={() =>
                        this.changeStudentsListPage(
                          this.state.studentsListPage - 1
                        )
                      }
                    >
                      <i className="fa fa-arrow-left" />
                    </button>
                    <div className="d-flex flex-row mx-1">
                      {this.renderStudentsListPageButtons()}
                    </div>
                    <button
                      className="rounded-circle bg-primary d-flex align-items-center justify-content-center p-2"
                      style={{ height: "32px", width: "32px" }}
                      disabled={
                        this.state.studentsListPage ===
                        this.state.studentsListLastPage
                      }
                      onClick={() =>
                        this.changeStudentsListPage(
                          this.state.studentsListPage + 1
                        )
                      }
                    >
                      <i className="fa fa-arrow-right" />
                    </button>
                  </div> */}
                  <CPagination
                    align="end"
                    className="mt-3"
                    activePage={this.state.studentsListPage}
                    pages={this.state.studentsListLastPage}
                    onActivePageChange={page =>
                      this.setState({ studentsListPage: page }, () =>
                        this.initializeActivity()
                      )
                    }
                  />
                </CTabPane>
              </CTabContent>
            </CTabs>
          </>
        ) : (
          <Loading top="45" left="50" />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityDo);
